import { render, staticRenderFns } from "./CertOld.vue?vue&type=template&id=bf4f9f84&scoped=true&"
import script from "./CertOld.vue?vue&type=script&lang=js&"
export * from "./CertOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4f9f84",
  null
  
)

export default component.exports